// A cooking timer ran out (feature spec 04): a short chime and a buzz, both
// behind Settings' "When a cooking timer ends" switch, the buzz also behind
// Vibration (haptic()). iPhone Safari has no navigator.vibrate, so the chime
// is what an iPhone hears; it plays only from an AudioContext created or
// resumed in a user gesture, which is why primeAlert() runs on "Start timer".
// The sound is generated (two short sine notes), so there is no asset.

import { getPrefs } from './prefsStore'
import { haptic } from './haptics'

export const TIMER_VIBRATION = [300, 120, 300, 120, 300] as const

type Ctx = AudioContext
let ctx: Ctx | null = null

function audio(): Ctx | null {
  if (ctx) return ctx
  const Ctor = (globalThis as { AudioContext?: new () => Ctx; webkitAudioContext?: new () => Ctx }).AudioContext
    ?? (globalThis as { webkitAudioContext?: new () => Ctx }).webkitAudioContext
  if (!Ctor) return null
  try { ctx = new Ctor() } catch { ctx = null }
  return ctx
}

/** Call from a tap: creates or wakes the audio context so the chime may play later. */
export function primeAlert(): void {
  const c = audio()
  if (c && c.state === 'suspended') c.resume().catch(() => {})
}

function chime(c: Ctx) {
  const t0 = c.currentTime
  for (const [i, freq] of [880, 1320].entries()) {
    const osc = c.createOscillator()
    const gain = c.createGain()
    osc.type = 'sine'
    osc.frequency.setValueAtTime(freq, t0)
    const start = t0 + i * 0.22
    gain.gain.setValueAtTime(0.0001, start)
    gain.gain.exponentialRampToValueAtTime(0.4, start + 0.02)
    gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.5)
    osc.connect(gain)
    gain.connect(c.destination)
    osc.start(start)
    osc.stop(start + 0.55)
  }
}

export function timerAlert(): void {
  if (!getPrefs().notifyTimer) return
  try {
    const c = audio()
    if (c) chime(c)
  } catch { /* no sound, still the buzz and the lime card */ }
  haptic(TIMER_VIBRATION)
}

/** Tests only. */
export function resetAlertForTests(): void {
  ctx = null
}
